import { BookOpenCheck, MapPin, ShieldCheck, Scale } from "lucide-react";

const STATS = [
  { icon: BookOpenCheck, value: "50+", label: "In-depth Pennsylvania guides" },
  { icon: MapPin, value: "20", label: "PA cities covered" },
  { icon: Scale, value: "16", label: "Accident types explained" },
  { icon: ShieldCheck, value: "100%", label: "Statutes cited & independently researched" },
];

export default function ContentAuthorityBand() {
  return (
    <section className="bg-forest text-bone border-y border-bone/10" data-testid="content-authority-band">
      <div className="max-w-7xl mx-auto px-6 py-8 md:py-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {STATS.map((s, i) => (
            <div key={i} className="flex items-start gap-3" data-testid={`authority-stat-${i}`}>
              <div className="w-10 h-10 rounded-lg bg-terracotta/15 text-terracotta grid place-items-center shrink-0">
                <s.icon className="w-5 h-5" />
              </div>
              <div>
                <div className="font-display font-black text-2xl md:text-3xl text-bone leading-none mb-1">{s.value}</div>
                <div className="text-xs md:text-sm text-bone/70 leading-snug">{s.label}</div>
              </div>
            </div>
          ))}
        </div>
        <p className="text-xs md:text-sm text-bone/50 mt-6 max-w-3xl leading-relaxed">
          Every guide is written specifically for Pennsylvania law and independently researched against the
          Pennsylvania Consolidated Statutes (42 Pa.C.S., 75 Pa.C.S.) — not copied from another state. We are a free
          referral service, not a law firm.
        </p>
      </div>
    </section>
  );
}
